import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { media } from '@sportson/core-web/utils/mediaqueries';
import AspectWrapper from '@sportson/core-web/components/AspectWrapper';
import { inServer } from '@sportson/core-web/constants';
import styled from 'libs/styled';

const Wrapper = styled('div')`
    width: 100%;
    height: 100%;

    & > div {
        height: 100%;
    }
    & > img,
    svg {
        margin: auto;
    }

    & > svg {
        filter: drop-shadow(1px 1px 10px hsl(206.5, 70.7%, 8%));
        transition: all 250ms ease-in-out;
    }

    ${media.hover} {
        &:hover svg {
            /* @TODO hover for video */
        }
    }

    &:hover {
        cursor: pointer;
    }
`;

const Thumbnail = styled('img')``;

const Iframe = styled('iframe')``;

const Youtube = ({ children, embedUrl, thumbnailSrc, ratio, objectFit = 'fill' }) => {
    const [showVideo, setShowVideo] = useState(false);

    useEffect(() => {
        const iframe = inServer ? [] : document.getElementById(embedUrl);

        const startVideo = () => {
            // For video to autoplay in mobile-devices, we need to send playVideo to the content-window, sending autoplay=1 in url only autoplays for desktop. This solution covers both.
            iframe && iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
        };

        if (showVideo) {
            // waits for video in iframe to finnish loading before executing autoplay command.
            iframe.addEventListener('load', () => startVideo());
        }

        return () => iframe && iframe.removeEventListener('load', startVideo);
    }, [showVideo]);

    return (
        <Wrapper onClick={() => setShowVideo(true)}>
            <AspectWrapper ratio={ratio}>
                {showVideo ? (
                    <Iframe
                        allowFullScreen
                        width="100%"
                        height="100%"
                        id={embedUrl}
                        // For autoplay to work on iOS we need to send the mute=1 in src-url to player, iOS can't autoplay with sound, but it's possible for android. enablejsapi=1 is for postMessage() to work.
                        src={`${embedUrl}?mute=1&enablejsapi=1`}
                        frameBorder="0"
                        className="ifrm"
                        rel="0"
                        allow="autoplay; encrypted-media"
                        title="Youtube video"
                    />
                ) : (
                    <>
                        <Thumbnail
                            objectFit={objectFit}
                            height="100%"
                            width="100%"
                            src={thumbnailSrc}
                            alt="Youtube video"
                        />
                        {children}
                    </>
                )}
            </AspectWrapper>
        </Wrapper>
    );
};

Youtube.propTypes = {
    children: PropTypes.object.isRequired,
    embedUrl: PropTypes.string.isRequired,
    ratio: PropTypes.number,
    thumbnailSrc: PropTypes.string.isRequired,
};

Youtube.defaultProps = {
    ratio: 1,
};

export default Youtube;
